import {Template, TemplateRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {TableCell} from "@mui/material";

export const TemplateListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<Template> = {
		title: "Plantillas ",
		onClick: "/app/admin/config/template",
		headers: [
			{title: "Nombre"}
		],
		decorator: (bean: Template) => <TableCell>{bean.name}</TableCell>,
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(TemplateRestControllerApiFactory);
			return ctrl.pageTemplate(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};